export default {
  'seo.common.title':
    'BEUKAY B2B e-commerce platform for packaging materials in cosmetics and packaging industries.',
  'seo.detail.title': '{name}_BEUKAY B2B Packaging Mall',
  'seo.menu.title': '{name}_BEUKAY B2B Packaging Mall',
  'seo.common.description':
    'BEUKAY B2B Packaging Mall provides, Packaging design, Packaging development, Material R&D, Product Manufacturing, Product trading, Supply Chain   Service Integrated Solutions.',
  'seo.detail.description': '{name}_BEUKAY B2B Packaging Mall',
  'seo.common.keywords':
    'BEUKAY， Packing Business ，Packaging Design，Packaging Development，Mould Development，Development of Materials.',
};
